import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/globeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/landmarkIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/timeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/CertifiedImg.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/ambee-logo-footer.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/X.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Buttons/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalSection"] */ "/app/src/components/Cards/ExternalSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferingSection"] */ "/app/src/components/Cards/OfferingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Cards/ScaleTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/DataInsights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/AnimationCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Client.tsx");
